/**
 * Width tiers — the two canonical size envelopes every `ResizablePanel` picks
 * from, instead of hand-choosing min/max/fraction per call site
 * (DESIGN-SYSTEM.md §3). A new panel picks by role, never free numbers.
 *
 * Spread a tier straight into the panel props:
 *   <ResizablePanel {...WIDTH_TIERS.rail} defaultWidth={240} … />
 */
export interface WidthTier {
  readonly minWidth: number;
  readonly maxWidth: number;
  readonly maxViewportFraction: number;
}

export const WIDTH_TIERS = {
  /** Rail / inspector — side panels flanking the primary pane (nav, details). */
  rail: { minWidth: 240, maxWidth: 560, maxViewportFraction: 0.42 },
  /** Primary content pane — the editor/board column; roomy, gives siblings 20%. */
  primaryPane: { minWidth: 320, maxWidth: 1600, maxViewportFraction: 0.8 },
} as const satisfies Record<string, WidthTier>;
